import { isBefore } from 'app/utils/dayjs';

export type InventoryWithUpdates = {
  rooms: Record<
    string | number,
    {
      plannings: Record<
        string,
        {
          packagePrices: Record<
            string | number,
            {
              updatedAt: string;
            }
          >;
        }
      >;
    }
  >;
};

export const getLastUpdateDate = (
  inventory?: InventoryWithUpdates
): Date | undefined => {
  if (!inventory) {
    return undefined;
  }

  try {
    const allUpdates = Object.values(inventory.rooms)
      .flatMap((room) => Object.values(room.plannings))
      .flatMap((planning) => Object.values(planning.packagePrices))
      .map((packagePrice) => packagePrice.updatedAt)
      .filter((date): date is string => !!date);

    if (allUpdates.length === 0) {
      return undefined;
    }

    const sortedUpdates = allUpdates.sort((a, b) => {
      return isBefore(new Date(a), new Date(b)) ? 1 : -1;
    });

    return new Date(sortedUpdates[0]);
  } catch (error) {
    console.error('Error extracting last update date:', error);

    return undefined;
  }
};
